import * as shippingInWarehouseApi from "../../backend/shipping-in-warehouseApi.js";
import { phaseTypeTitles } from "../../views/shippings/components/phases/shipping-phase-types.js";

const state = {
  headers: [
    {
      title: "",
      sortable: false,
      name: "filter_list",
      type: "icon",

    },
    {
      title: "Запросы",
      sortable: false,
    },
    {
      title: "Уведомления",
      sortable: false,
    },
    {
      title: "№ поставки",
      sortable: false,
      name: "shippingNumber",
      dataPath: "shipping.number",
      type: "link",
    },
    {
      title: "Клиент",
      sortable: false,
      name: "client",
      valueFn(item) {
        return item.shipping?.client?.title || "";
      },
    },
    {
      title: "Клиент по документам",
      sortable: false,
      name: "clientAlias",
      dataPath: "shipping.clientAlias",
    },
    {
      title: "Продавец",
      sortable: false,
      name: "sender",
      dataPath: "shipping.sender",
    },
    {
      title: "Откуда",
      sortable: false,
      name: "shippingPhaseFrom",
      valueFn(item) {
        if (!item.shippingPhaseFrom) {
          const dash = "\u2013";
          return dash;
        }
        const address = item.shippingPhaseFrom.arrivalPoint?.address?.title || "";
        return `${address}`;
      },
      tooltip: true,
    },
    {
      title: "Контрагент(приход)",
      sortable: false,
      name: "сounterpartyFrom",
      valueFn(item) {
        if (!item.shippingPhaseFrom) {
          const dash = "\u2013";
          return dash;
        }
        return item.shippingPhaseFrom.counterparty?.carrier?.title ||
          item.shippingPhaseFrom.counterparty?.client?.title ||
          item.shippingPhaseFrom.counterparty?.warehouse?.title || "";
      },
    },
    {
      title: "Тип звена 1/ маршрут",
      sortable: false,
      name: "firstPhase",
      valueFn(item) {
        if (!item.shippingPhaseFrom) {
          const dash = "\u2013";
          return dash;
        }
        const phaseType = phaseTypeTitles[item.shippingPhaseFrom.type?.id - 1] || "";
        const route = item.shippingPhaseFrom.route?.title || "";
        return route ? `${phaseType} / ${route}` : phaseType;
      },
    },
    {
      title: "Склад",
      sortable: false,
      name: "warehouse",
      valueFn(item) {
        if (!item.shippingPhaseFrom) {
          return item.shippingPhaseTo?.sendingPoint?.warehouse?.title || item.shippingPhaseTo?.sendingPoint?.factory?.title || "";
        } else {
          return item.shippingPhaseFrom?.arrivalPoint?.warehouse?.title || item.shippingPhaseFrom?.arrivalPoint?.factory?.title || "";
        }
      },
    },
    {
      title: "№ складской",
      sortable: false,
      name: "warehouseNumber",
      editor: "TEXT",
      method: "updateWarehouseNumber",
    },
    {
      title: "Куда",
      sortable: false,
      name: "shippingPhaseTo",
      valueFn(item) {
        if (!item.shippingPhaseTo && item.shippingPhaseFrom.isLast) {
          const dash = "\u2013";
          return dash;
        }
        if (!item.shippingPhaseTo) {
          return "";
        }
        const address = item.shippingPhaseTo.arrivalPoint?.address?.title || "";
        return `${address}`;
      },
    },
    {
      title: "Контрагент(уход)",
      sortable: false,
      name: "counterpartyTo",
      valueFn(item) {
        if (!item.shippingPhaseTo && item.shippingPhaseFrom.isLast) {
          const dash = "\u2013";
          return dash;
        }
        if (!item.shippingPhaseTo) {
          return "";
        }
        return item.shippingPhaseTo.counterparty?.carrier?.title ||
          item.shippingPhaseTo.counterparty?.client?.title ||
          item.shippingPhaseTo.counterparty?.warehouse?.title;
      },
    },
    {
      title: "Статус на складе",
      sortable: false,
      name: "state",
      dataPath: "state",
      editor: "TRANSITION",
    },
    {
      title: "Тип звена 2/ маршрут",
      sortable: false,
      name: "secondPhase",
      valueFn(item) {
        if (!item.shippingPhaseTo && item.shippingPhaseFrom.isLast) {
          const dash = "\u2013";
          return dash;
        }
        if (!item.shippingPhaseTo) {
          return "";
        }
        const phaseType = phaseTypeTitles[item.shippingPhaseTo.type?.id - 1] || "";
        const route = item.shippingPhaseTo.route?.title || "";
        return route ? `${phaseType} / ${route}` : phaseType;
      },
    },
  ],
  items: [],
  columnsSetting: null,
  savedSettings: [],
  columns: [],
  selectedSetting: null,
  editingCell: null,
};
const getters = {
  headers: state => {
    return state.headers;
  },
  items: state => {
    return state.items;
  },
  columnsSetting(state) {
    return state.columnsSetting;
  },
  savedSettings(state) {
    return state.savedSettings;
  },
  columns(state) {
    return state.columns;
  },
  selectedSetting(state) {
    return state.selectedSetting;
  },
  editingCell(state) {
    return state.editingCell;
  },
};
const mutations = {
  setItems(state, value) {
    state.items = value;
  },
  setColumnsSetting(state, columnsSetting) {
    state.columnsSetting = columnsSetting;
  },
  setSavedSettings(state, savedSettings) {
    state.savedSettings = savedSettings;
  },
  setColumns(state, columns) {
    state.columns = columns;
  },
  setSelectedSetting(state, value) {
    state.selectedSetting = value;
  },
  setEditingCell(state, value) {
    state.editingCell = value;
  },
};

const actions = {
  async getData({ commit, getters }) {
    const result = await shippingInWarehouseApi.getWarehouseDetails();
    const columns = getters.headers;
    const items = result.map(i => {
      const item = { id: i.id, shippingId: i.shipping.id };
      columns.forEach(c => {
        if (c.type === "icon") {
          return;
        } else if (c.dataPath) {
          const dataPathSegments = c.dataPath.split(".");
          let value = i;
          dataPathSegments.forEach(s => (value ? (value = value[s]) : ""));
          item[c.name] = value;
        } else if (c.valueFn && !c.tooltip) {
          item[c.name] = c.valueFn(i);
        } else if (c.valueFn && c.tooltip) {
          item[c.name] = c.valueFn(i);
          const dash = "\u2013";
          item.tooltip = item[c.name] != dash ? true : false;
        } else {
          item[c.name] = i[c.name];
        }
      });
      return item;
    });
    commit("setItems", items);
  },
  assignEditingCell({ commit }, value) {
    commit("setEditingCell", value);
  },
  async updatePhase({ commit, getters }, value) {
    const cell = getters.editingCell;
    const items = getters.items;
    await shippingInWarehouseApi[cell.column.method](cell.item.id, value);
    items.forEach((i) => {
      if (i.id === cell.item.id) {
        i[cell.column.name] = value;
      }
    });
    commit("setItems", items);
  },
  async changeWarehousePhaseState({ getters, commit }, value) {
    if (value.transition.isNext) {
      await shippingInWarehouseApi.changeWarehousePhaseState(
        value.phaseId,
        value.transition.id,
      );
    }
    if (value.transition.isPrev) {
      await shippingInWarehouseApi.backToPrevWarehousePhaseState(
        value.phaseId,
        value.transition.id,
      );
    }

    const items = getters.items;
    items.forEach((i) => {
      if (i.id === value.phaseId) {
        i[value.columnName] = value.transition.id;
      }
    });
    commit("setItems", items);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
